module.exports = __webpack_public_path__ + "static/media/1_pl.37302e5a.png";